import React, { useEffect } from "react";
import { useGetCountryGeoQuery } from "@me-team/host/main/branches/graphql/branches.hooks";
import { useReactiveVar } from "@apollo/client";
import { currentCompanyIdVar } from "@me-team/host/main/globalVar/state";

const EXCLUDE_HOTJAR_COUNTRIES = new Set(["UA", "CZ"]);
const HOTJAR_ID = "3911500";

const GlobalWidgets: React.FC = () => {
    const isProduction = process.env.REACT_APP_RELEASE_ENVIRONMENT === "prod";

    const currentCompanyId = useReactiveVar(currentCompanyIdVar);

    const { data: countryGeoData } = useGetCountryGeoQuery({
        skip: !currentCompanyId || !isProduction,
    });

    const isoCode = countryGeoData?.countryGeo?.country?.isoCode;

    useEffect(() => {
        if (!isProduction || !isoCode || EXCLUDE_HOTJAR_COUNTRIES.has(isoCode)) {
            return;
        }

        const scriptId = `hotjar-${HOTJAR_ID}`;
        if (document.getElementById(scriptId)) return;

        const hotjarScript = document.createElement("script");
        hotjarScript.id = scriptId;
        hotjarScript.async = true;
        hotjarScript.innerHTML = `
            (function(h,o,t,j,a,r){
                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                h._hjSettings={hjid:${HOTJAR_ID},hjsv:6};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `;

        document.head.appendChild(hotjarScript);
    }, [isoCode, isProduction]);

    return null;
};

export default GlobalWidgets;
